import Vue from 'vue'
import Router from 'vue-router'

import AllPatients from '@/views/AllPatients.vue'
import MedicalRecord from '@/components/MedicalRecord.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MedicalRecord',
      component: MedicalRecord
    },
    {
      path: '/all',
      name: 'AllPatients',
      component: AllPatients
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})